var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-form-input", {
        attrs: {
          id: "input-work-service",
          size: "sm",
          disabled: this.$props.isDisabled,
          placeholder: "Вид услуг",
          autocomplete: "off"
        },
        on: { focus: _vm.onFocusIn, blur: _vm.onFocusOut },
        model: {
          value: _vm.query,
          callback: function($$v) {
            _vm.query = $$v
          },
          expression: "query"
        }
      }),
      _vm._v(" "),
      _vm.isFocus
        ? _c(
            "b-list-group",
            { staticClass: "autocomplete-input-work-service" },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "b-list-group-item",
                {
                  key: index,
                  attrs: { button: "" },
                  on: {
                    mousedown: function($event) {
                      return _vm.onClick(item)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.getItemListText(item)) + "\n    "
                  )
                ]
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bf91db5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bf91db5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/WorkServices/WorkServiceSelect.vue
// module id = null
// module chunks = 